"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _common = require("@insided/shared/utils/common");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _TopicListItem = _interopRequireDefault(require("@insided/destination/modules/Content/TopicList/TopicListItem"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'category-topic-list-view';
exports.cssAnchorName = cssAnchorName;

var CategoryTopicListView = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategoryTopicListView, _Component);

  var _super = _createSuper(CategoryTopicListView);

  function CategoryTopicListView() {
    (0, _classCallCheck2.default)(this, CategoryTopicListView);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CategoryTopicListView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attachmentCdn = _this$props.attachmentCdn,
          headerSlot = _this$props.headerSlot,
          customPaginationSlot = _this$props.customPaginationSlot,
          topics = _this$props.topics,
          authors = _this$props.authors,
          hasMore = _this$props.hasMore,
          _this$props$isLoading = _this$props.isLoading,
          isLoading = _this$props$isLoading === void 0 ? false : _this$props$isLoading,
          onShowMore = _this$props.onShowMore,
          wrapperClassName = _this$props.wrapperClassName;

      if (!topics || topics.length === 0) {
        return (0, _preact.h)("div", {
          className: wrapperClassName
        }, headerSlot !== null && headerSlot !== void 0 ? headerSlot : null, (0, _preact.h)("div", {
          className: "empty-state"
        }, (0, _preact.h)(_phrase.default, {
          p: "no.topics.found"
        })));
      }

      return (0, _preact.h)("div", {
        className: wrapperClassName
      }, (0, _preact.h)("div", {
        className: "list-widget-wrapper"
      }, headerSlot !== null && headerSlot !== void 0 ? headerSlot : null, topics.map(function (topic) {
        return (0, _preact.h)(_TopicListItem.default, {
          key: topic.privateId,
          authors: authors,
          hideCategoryMetadata: topic.contentType === 'idea' && _common.common.isModuleActive('ideationV2') && !_common.common.isModuleActive('categoriesV2IdeasAndPU') || topic.contentType === 'productUpdate' && !_common.common.isModuleActive('categoriesV2IdeasAndPU'),
          topic: topic,
          attachmentCdn: attachmentCdn
        });
      }), customPaginationSlot !== null && customPaginationSlot !== void 0 ? customPaginationSlot : hasMore && (0, _preact.h)("div", {
        className: "load-more-container load-more-topics",
        key: "load-more"
      }, (0, _preact.h)("button", {
        className: (0, _classnames.default)('btn--cta', 'btn--full-width', 'btn--load-more', {
          'is-loading': isLoading
        }),
        onClick: onShowMore,
        type: "button",
        disabled: isLoading
      }, (0, _preact.h)(_phrase.default, {
        p: "Show more"
      }), (0, _preact.h)("span", {
        className: "loader"
      })))));
    }
  }]);
  return CategoryTopicListView;
}(_preact.Component);

exports.default = CategoryTopicListView;